export class RouteHelper {
    static assign(map1, map2) {
        const keys1 = Object.keys(map1);
        if (keys1.length === 0) {
            return map2;
        }
        const keys2 = Object.keys(map2);
        if (keys2.length === 0) {
            return map1;
        }
        const keys = keys1.concat(keys2);
        const map = {};
        for (const key of keys) {
            const item1 = map1[key];
            if (!item1) {
                map[key] = map2[key];
            }
            else if (!map2[key]) {
                map[key] = item1;
            }
            else {
                if (!item1.root) {
                    map[key] = map2[key];
                }
                else {
                    map[key] = RouteHelper.assign(item1, map2[key]);
                }
            }
        }
        return map;
    }
    static toRoutes(map) {
        const routes = Object.keys(map).map(key => {
            const item = Object.assign({}, map[key]);
            const root = item.root;
            if (root) {
                delete item.root;
                root.children = RouteHelper.toRoutes(item);
                return root;
            }
            else {
                return item;
            }
        });
        return routes;
    }
}
